import type { ComponentProps } from "react"
import { AccordionContent as AccordionContentBase } from "@/v2-ui/accordion/base/AccordionBase"
import cn from "@/v2-ui/utils/utils.cn"

export type AccordionContentProps = ComponentProps<typeof AccordionContentBase>

function AccordionContent(props: AccordionContentProps) {
  const { className, ...accordionContentBaseProps } = props
  return (
    <AccordionContentBase
      className={cn("ui-accordion-content", className)}
      {...accordionContentBaseProps}
    />
  )
}

export default AccordionContent
